import { BodyCopy as LolaBodyCopy } from "lola-framework-ui-test";
import type { ComponentProps } from "react";

/**
 * lola BodyCopy advertises `textColor` but spreads it onto the DOM `<p>`.
 * Strip it here and apply as inline color so React stops warning.
 */
export function BodyCopy({
  textColor,
  background,
  style,
  ...props
}: ComponentProps<typeof LolaBodyCopy> & {
  textColor?: string;
  background?: string;
}) {
  return (
    <LolaBodyCopy
      {...props}
      style={{
        ...(textColor ? { color: textColor } : {}),
        ...(background ? { background } : {}),
        ...style,
      }}
    />
  );
}
